import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

export const queryKey = (shopId: string) => ["get", "/shops/{shopId}/carriers", { params: { path: { shopId } } }];

export const useCarriersQuery = (shopId: string) => {
  const query = $api.useQuery("get", "/shops/{shopId}/carriers", {
    params: { path: { shopId } },
  });
  return query;
};

export const useCarriersSuspenseQuery = (shopId: string) => {
  const query = $api.useSuspenseQuery("get", "/shops/{shopId}/carriers", {
    params: { path: { shopId } },
  });
  return query;
};

export const useInvalidateCarriersQuery = ({ shopId }: { shopId: string }) => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: queryKey(shopId),
    });
  };
};
